<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7yY9xI/media/FC-9789948760153.jpg?1725276967842" alt="This image is the cover for the book Enchanters: Royal Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enchanters: Royal Secrets
      </h1>
      <p class="bookDescription body article font2">
        <p>Now that I had enrolled myself in the most well-known academy, Silverstring Academy for Enchanters and Enchantresses. Now that I had begun to blend in with my kind—the magical kind. All I wanted was normal schooling and to get to know my roots better. Little did I know that my roots were rotten to the core. I was 17, a teenager, when I ascended to the throne; forced into marriage with the most demonic king Ariesque had ever known. People feared his name, but he knew my past, knew my parents, and he killed them. He knew me, yet I had never met him before. They call him Maldeus—God of Death. But I was in love with the prince who was secretly enrolled in the academy when I took the throne. Years later, here I am, justifying my choices to the Enchanter’s Community. Why I murdered my close ones, why I took up the throne, and what happened to my love story with the prince.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.M. Sequeira
      </h2>
      
      <p class="authorDescription body article">A. M. Sequeira is currently a medical student studying in Tbilisi. She is from India and enjoys spending the final three hours of her night living in another world through writing. She dislikes the idea of a monotonous life; the very idea that many people hate to visualize. She wishes to wake up every day to adrenalin rush but realizes that life is expensive, demanding countless degrees and experiences. It is through her debut book as a first-time author that she explores the aspects of different lives in a single life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07a4d256